import { render, staticRenderFns } from "./OnboardingHome.vue?vue&type=template&id=f4c2a860&scoped=true&"
import script from "./OnboardingHome.vue?vue&type=script&lang=js&"
export * from "./OnboardingHome.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingHome.vue?vue&type=style&index=0&id=f4c2a860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c2a860",
  null
  
)

export default component.exports